import client from '../axios';
import { GET_SCHEDULE_HQ, GET_SCHEDULE_BRANCH, POST_SCHEDULE, GET_SCHEDULE_DETAIL, PUT_SCHEDULE, DELETE_SCHEDULE, GET_SCHEDULE_LIST_TOP5 } from 'api/endpoint';

//리스트-본사
export const getHqScheduleAPI = (params) => {
  
  let url = GET_SCHEDULE_HQ.replace(':level_no/:team_idx', params.level_no + '/' + params.team_idx);
  return client.get(url,{params});
};
//리스트-본사
export const getHqScheduleTop5API = () => {
  let url = GET_SCHEDULE_LIST_TOP5;
  return client.get(url);
};
//리스트-지사
export const getBranchScheduleAPI = (params) => {
  let url = GET_SCHEDULE_BRANCH.replace(':level_no/:team_idx', params.level_no + '/' + params.team_idx);
  return client.get(url);
};


//일정 추가
export const postScheduleAPI = (params) => {
  return client.post(POST_SCHEDULE, params);
};

//상세
export const getScheduleDetailAPI = (idx) => {
  const url = GET_SCHEDULE_DETAIL.replace(':schedule_idx', idx);
  return client.get(url);
};
//수정
export const putScheduleAPI = (params) => {
  console.log(params);
  const url = PUT_SCHEDULE.replace(':schedule_idx', params.idx);
  return client.put(url, params);
};
//삭제
export const deleteScheduleAPI = (arr) => {
  console.log(arr);
  const url = DELETE_SCHEDULE;
  return client.post(url, arr);
};
